// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import React from "react";
import { connect } from "react-redux";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import { css } from "styled-components";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import translate from "@insite/client-framework/Translate";

const mapStateToProps = (state: ApplicationState) => ({
    cart: getCurrentCartState(state).value,
});

type Props = ReturnType<typeof mapStateToProps>;

export interface OrderExceedingWarningStyles {
    infosBox?: InfosBoxProps;
    warningHeadline?: TypographyPresentationProps;
}

export const orderExceedingWarningStyles: OrderExceedingWarningStyles = {
    infosBox: {
        type: "warning",
        extendedStyles: {
            wrapper: {
                css: css`
                    p {
                        ${spacingStyles("0", "0")}
                    }
                `,
            },
        },
    },
    warningHeadline: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.semibold};
            display: block;
        `,
    },
};

const styles = orderExceedingWarningStyles;

const OrderExceedingWarning = ({ cart }: Props) => {
    if (!cart) {
        return null;
    }

    const isOver = cart.properties.isOverOnlinePurchaseLimit === "true";
    const purchaseLimit = cart.properties.onlinePurchaseLimitDisplay;

    if (!isOver || !purchaseLimit) {
        return null;
    }

    return (
        <InfosBox {...styles.infosBox}>
            <Typography {...styles.warningHeadline}>
                {translate("PurchaseLimit_Headline").replace("{0}", purchaseLimit)}
            </Typography>
            <Typography>{translate("PurchaseLimit_Text").replace("{0}", purchaseLimit)}</Typography>
        </InfosBox>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderExceedingWarning),
    definition: {
        displayName: "Order Exceeding Warning",
        group: "Cart",
        icon: "circle-i",
    },
};

export default widgetModule;
